import { EditActionIcon } from '@common';

type EditPropsType = {
  onClick: () => void;
};

export const Edit: React.FC<EditPropsType> = ({ onClick }) => {
  return <EditActionIcon onClick={onClick} />;
};
